import {useDispatch} from 'react-redux';
import {useCallback} from 'react';
import * as React from 'react';

import routeByName from '~/constants/routes';
import useModalById from '~/customHooks/useModalById';
import {MODAL_SIGN_UP_REQUEST} from '~/rootStore/modals/modalsIds';
import {navigateAction} from '~/actions/navigateActions';

import ModalBase from '../ModalBase';
import ModalBaseContent from '../ModalBaseContent';
import image from './img/register-anonymously.svg';

const ModalSignUpRequest: React.FC = () => {
  const dispatch = useDispatch();
  const {isOpen, close, props} = useModalById(MODAL_SIGN_UP_REQUEST);
  const handleActionClick = useCallback(() => {
    close();
    dispatch(navigateAction(routeByName.signUp));
  }, [close, dispatch]);

  const {showSkip = true} = props;

  return (
    <ModalBase showCloseButton showSkipButton={showSkip} open={isOpen} onClose={() => close()}>
      <ModalBaseContent
        image={image}
        title="Register Anonymously"
        description="Register anonymously FREE to remove chat limits, manage your favorite contacts, keep chat history and get more extra features"
        actionButtonText="Register Anonymously"
        onClickActionButton={handleActionClick}
      />
    </ModalBase>
  );
};

export default ModalSignUpRequest;
